var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioRecord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,28A14,14,0,0,1,4.1,4.1,14,14,0,0,1,23.9,23.9,13.908,13.908,0,0,1,14,28Zm-2.457-8.4a.465.465,0,0,0-.346.153.522.522,0,0,0,0,.724.465.465,0,0,0,.346.153h4.912a.465.465,0,0,0,.346-.153.522.522,0,0,0,0-.724.465.465,0,0,0-.346-.153H14.491V18.541a4.243,4.243,0,0,0,2.8-1.507,4.607,4.607,0,0,0,1.133-3.091V12.914a.509.509,0,0,0-.147-.362.466.466,0,0,0-.69,0,.508.508,0,0,0-.146.362v1.029a3.567,3.567,0,0,1-1.01,2.544,3.319,3.319,0,0,1-4.858,0,3.566,3.566,0,0,1-1.009-2.544V12.914a.508.508,0,0,0-.146-.362.467.467,0,0,0-.691,0,.508.508,0,0,0-.146.362v1.029a4.607,4.607,0,0,0,1.132,3.091,4.244,4.244,0,0,0,2.8,1.507V19.6ZM14,7.368a2.2,2.2,0,0,0-1.669.756,2.6,2.6,0,0,0-.694,1.816v4.117a2.6,2.6,0,0,0,.694,1.816,2.219,2.219,0,0,0,3.337,0,2.6,2.6,0,0,0,.695-1.816V9.941a2.6,2.6,0,0,0-.695-1.816A2.2,2.2,0,0,0,14,7.368Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioRecord);
export default __webpack_public_path__ + "static/media/audio_record.d1441ea07e793be2b899bf01a7ad30c0.svg";
export { ForwardRef as ReactComponent };